import { Container } from "./style";

export function Xp() {
  return (
    <Container>
      <hr />
      <h1 id="xp">Experiências:</h1>
      <p className="titulo">Desenvolvedor Full-Stack</p>
      <p className="tempo">Dez.2021 - Atualmente</p>
      <p className="tipo">Freelance</p>
      <p className="detalhes">
        Desenvolvo landing pages de maneira independente, utilizando HTML | CSS
        | JS | REACT | NEXT | ANGULAR | .NET | NODE | EXPRESS | NEST com o propósito de ampliar a visibilidade dos
        seus produtos ou serviços.
        <br />
        Experiência em desenvolvimento de sistemas para diversos setores, como saúde, imobiliário, eventos sociais, educação, importadora, fábrica e transporte.<br />
        <br />
      </p>
      <p className="titulo">Desenvolvedor Full-Stack</p>
      <p className="tempo">Ago.2022 - Mai.2024</p>
      <p className="tipo">Thinker</p>
      <p className="detalhes">
        Participei da equipe de desenvolvimento (Squad Pilots) da empresa{" "}
        <a href="https://thinkam.net/home" target="_blank" rel="noreferrer">
          {" "}
          Think A.M.{" "}
        </a>{" "}
        tenho como foco desenvolver landing pages e sistemas de CRM's. <br />
        Desenvolvi projetos para grandes empresas como a trasnportadora 
        <a href="https://www.instagram.com/updelivery_/" target="_blank" rel="noreferrer">
          {" "}
          UpDelivery,{" "}
        </a>{" "}
         na empresa de pesquisa fisioterapeutica
        <a href="http://www.stepslab.com.br/" target="_blank" rel="noreferrer">
          {" "}
          Steps{" "}
        </a>{" "}
        e na empresa de podologia
        <a href="https://clinicabompe.com.br/home" target="_blank" rel="noreferrer">
          {" "}
          Clinica Bom Pé.{" "}
        </a>{" "}
        <br />
        <br />
      </p>
      <hr />
    </Container>
  );
}
